import { z } from 'zod';

/**
 * De emoji's waarmee je op een bericht kunt reageren (BER-8).
 *
 * Een vaste, kleine set en een sleutel per emoji: de app tekent het teken, de server kent alleen de
 * naam. Eén reactie per persoon per bericht — een andere kiezen vervangt de vorige.
 */
export const reactionEmojiSchema = z.enum(['thumbs_up', 'heart', 'laugh', 'wow', 'sad', 'thanks']);
export type ReactionEmoji = z.infer<typeof reactionEmojiSchema>;

/** Hoeveel mensen met deze emoji reageerden. Geen namen (ADR-0014). */
export const messageReactionSummarySchema = z.object({
  emoji: reactionEmojiSchema,
  count: z.number().int().positive(),
});
export type MessageReactionSummary = z.infer<typeof messageReactionSummarySchema>;

/**
 * Het bericht waarop dit bericht antwoordt, zoals het in het citaat boven de ballon staat.
 *
 * `available: false` als dat bericht intussen weg is: het antwoord blijft staan, het citaat zegt
 * dan dat het oorspronkelijke bericht verwijderd is. De tekst is ingekort; het citaat is een
 * herinnering, geen kopie.
 */
export const messageReplySchema = z.object({
  id: z.guid(),
  senderDisplayName: z.string(),
  body: z.string(),
  hasAttachments: z.boolean(),
  available: z.boolean(),
});
export type MessageReply = z.infer<typeof messageReplySchema>;
